// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/capture_team.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { AddAccountMemberRequest, AddAccountMemberResponse, AddNamedContributorRequest, AddNamedContributorResponse, ListCaptureTeamRequest, ListCaptureTeamResponse, RemoveCaptureTeamMemberRequest, RemoveCaptureTeamMemberResponse, SetCaptureTeamOwnerRequest, SetCaptureTeamOwnerResponse } from "./capture_team_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * CaptureTeamService is the browser-facing typed Pursuit team (SAD-482),
 * implemented by zou over pangaea's CaptureTeamGatewayService.
 *
 * The tenant and caller come ONLY from the gateway principal; no request
 * carries one. Every RPC authorizes through the capture_project growth
 * resolver seam (list = "read", mutations = "update"). A pursuit outside the
 * caller's tenant is NotFound.
 *
 * A member is an `account` (a live identity user in the tenant) or `named`
 * (a recorded contributor with a role). Adding a named contributor creates
 * ONLY a team row: no identity user, role assignment, grant or source access.
 * Exactly one account member is the accountable owner, who cannot be removed;
 * transfer with SetCaptureTeamOwner.
 *
 * @generated from service mono.projectdata.v1.CaptureTeamService
 */ export const CaptureTeamService = {
    typeName: "mono.projectdata.v1.CaptureTeamService",
    methods: {
        /**
     * @generated from rpc mono.projectdata.v1.CaptureTeamService.ListCaptureTeam
     */ listCaptureTeam: {
            name: "ListCaptureTeam",
            I: ListCaptureTeamRequest,
            O: ListCaptureTeamResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.CaptureTeamService.AddNamedContributor
     */ addNamedContributor: {
            name: "AddNamedContributor",
            I: AddNamedContributorRequest,
            O: AddNamedContributorResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.CaptureTeamService.AddAccountMember
     */ addAccountMember: {
            name: "AddAccountMember",
            I: AddAccountMemberRequest,
            O: AddAccountMemberResponse,
            kind: MethodKind.Unary
        },
        /**
     * FailedPrecondition when the member is the owner.
     *
     * @generated from rpc mono.projectdata.v1.CaptureTeamService.RemoveCaptureTeamMember
     */ removeCaptureTeamMember: {
            name: "RemoveCaptureTeamMember",
            I: RemoveCaptureTeamMemberRequest,
            O: RemoveCaptureTeamMemberResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.CaptureTeamService.SetCaptureTeamOwner
     */ setCaptureTeamOwner: {
            name: "SetCaptureTeamOwner",
            I: SetCaptureTeamOwnerRequest,
            O: SetCaptureTeamOwnerResponse,
            kind: MethodKind.Unary
        }
    }
};
